import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Formate un numéro en format international lisible (ex: +33 7 82 36 64 79)
 */
export const formatInternationalPhone = (input) => {
  try {
    const phoneNumber = parsePhoneNumberFromString(input);
    if (phoneNumber && phoneNumber.isValid()) {
      return phoneNumber.formatInternational();
    }
    return input;
  } catch {
    return input;
  }
};

/**
 * Nettoie et normalise un numéro en format E.164 (ex: +33782366479)
 */
export const nettoyerPhone = (input) => {
  try {
    const phoneNumber = parsePhoneNumberFromString(input);
    if (phoneNumber && phoneNumber.isValid()) {
      return phoneNumber.number; // format E.164 (+XX...)
    }
    return input.replace(/\D/g, "");
  } catch {
    return input.replace(/\D/g, "");
  }
};

/**
 * Vérifie si un numéro est valide
 */
export const isValidPhone = (input) => {
  try {
    const phoneNumber = parsePhoneNumberFromString(input);
    return phoneNumber ? phoneNumber.isValid() : false;
  } catch {
    return false;
  }
};

/**
 * Construit un numéro complet en E.164
 * en retirant le 0 national si besoin (France, Belgique, Italie, Suisse, UK…)
 */
export const buildFullNumber = (indicatif, numero) => {
  const digits = (numero || "").replace(/\D/g, "");

  // Liste des indicatifs où il faut retirer le 0 national
  const trunkZero = new Set(["+33", "+32", "+39", "+41", "+44"]);
  const needsStrip = trunkZero.has(indicatif);

  const national = needsStrip && digits.startsWith("0")
    ? digits.slice(1)
    : digits;

  return `${indicatif}${national}`;
};

